var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoresLogo9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F1F4F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_4792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7937 33.7587V23.2038C52.7937 22.5387 52.2531 22 51.5857 22H47.5877C46.9202 22 46.3796 22.5387 46.3796 23.2038V33.7587C46.3796 37.6561 41 40.8485 41 45.0318V76.1976C41 77.1953 41.8143 78.0067 42.8154 78.0067H49.59H56.3646C57.3657 78.0067 58.18 77.1953 58.18 76.1976V45.0318C58.1733 40.8485 52.7937 37.6561 52.7937 33.7587Z",
    fill: "#2B5B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.793 33.7587H46.3789V23.2038C46.3789 22.5387 46.9195 22 47.587 22H51.585C52.2524 22 52.793 22.5387 52.793 23.2038V33.7587Z",
    fill: "#D7513E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8613 26.5558H46.3137C45.7597 26.5558 45.3125 26.1102 45.3125 25.5582C45.3125 25.0062 45.7597 24.5606 46.3137 24.5606H52.8613C53.4153 24.5606 53.8625 25.0062 53.8625 25.5582C53.8625 26.1036 53.4153 26.5558 52.8613 26.5558Z",
    fill: "#EB8F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9346 47.885H44.2422V70.5511H54.9346V47.885Z",
    fill: "#EB8F48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_4792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1733,
    height: 56,
    fill: "white",
    transform: "translate(41 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresLogo9);
export default __webpack_public_path__ + "static/media/stores-logo-9.d8ef1820e68d394c8d0aa00d64b96740.svg";
export { ForwardRef as ReactComponent };